import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {actions as addressActions} from '../redux/modules/Address'

import italia from '../vendor/italia'
import SostaOnlineApiService from '../services/SostaOnlineApiService'
import BackOfficeUserEditScreen from '../screens/BackOfficeUserEditScreen'

const mapStateToProps = (state) => {
  return {
    state: state.users,
    addresses: state.address
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addressActions: bindActionCreators(addressActions, dispatch)
  }
}

const ITALIA_COMUNI = italia.comuni.map(item => {
  const label = item.comune + ' (' + item.provincia + ')'
  return {
    label: label,
    value: label
  }
})

const ITALIA_COMUNI_SENZA_LODI_E_ESTERO = ITALIA_COMUNI.slice(2, ITALIA_COMUNI.length)

const randomPassword = (length = 5) => {
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let text = ''

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }

  return text
}

class BackOfficeUserEditContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      error: null,
      userTypes: [],
      categories: [],
      userEditResult: {},
      userId: props.match.params.id,
      user: {},
      values: {},
      success: false,
      areas: [],
      selectedCategories: [],
      selectedParkingSpaceArea: null
    }

    this.onGenerateUserCredentials = this.onGenerateUserCredentials.bind(this)
    this.onCategoriesChange = this.onCategoriesChange.bind(this)
    this.onParkingSpaceAddressSelected = this.onParkingSpaceAddressSelected.bind(this)
  }

  async componentWillMount () {
    await this.fetchUserCategories()
    this.fetchUser()
    this.fetchAreas()
    this.props.addressActions.fetchAddresses()
  }

  fetchUser () {
    this.setState({loading: true})
    SostaOnlineApiService.fetchUser(this.state.userId).then(data => {
      let residenceArea
      let workArea

      if (data.data.workArea) {
        workArea = data.data.workArea.id
      }

      if (data.data.residenceArea) {
        residenceArea = data.data.residenceArea.id
      }

      let parkingSpaceAddressId
      let parkingSpaceArea
      if (data.data.parkSpaceAddress) {
        parkingSpaceAddressId = data.data.parkSpaceAddress.id
        parkingSpaceArea = data.data.parkSpaceAddress.Area
      }

      this.setState({
        user: data.data,
        loading: false,
        selectedParkingSpaceArea: parkingSpaceArea,
        values: {
          firstName: data.data.firstName,
          lastName: data.data.lastName,
          email: data.data.email,
          phone: data.data.phone,
          fiscalCode: data.data.fiscalCode,
          userCategories: data.data.categories.map(item => {
            return {
              value: item.id,
              label: item.label.charAt(0).toUpperCase() + item.label.slice(1)
            }
          }),
          residenceAddress: data.data.residenceAddress,
          residenceCivicNumber: data.data.residenceCivicNumber,
          residenceCap: data.data.residenceCap,
          secondaryResidenceAddress: data.data.secondaryResidenceAddress,
          secondaryResidenceCity: data.data.secondaryResidenceCity,
          secondaryResidenceCap: data.data.secondaryResidenceCap,
          birthDate: data.data.birthDate,
          birthPlace: data.data.birthPlace,
          sex: data.data.sex,
          companyName: data.data.companyName,
          companyLegalAddress: data.data.companyLegalAddress,
          workCity: data.data.workCity,
          workCap: data.data.workCap,
          vatNumber: data.data.vatNumber,
          workAddress: data.data.workAddress,
          workCivicNumber: data.data.workCivicNumber,
          workAreaId: workArea,
          residenceAreaId: residenceArea,
          parkingSpaceAddress: parkingSpaceAddressId,
         // parkSpaceAddressId: data.parkSpaceAddress.id
        },
        selectedCategories: this.mapCategories(data.data.categories)
      })
    })
  }

  mapCategories (items) {
    return items.map(item => {
      let children = null
      if (item.Children && item.Children.length > 0) {
        children = this.mapCategories(item.Children)
      }

      return {
        value: item.id,
        label: item.label.charAt(0).toUpperCase() + item.label.slice(1),
        children: children,
        resident: item.resident,
        worker: item.worker,
        parkingInDifferentPlace: item.parkingInDifferentPlace
      }
    })
  }

  fetchUserTypes () {
    this.setState({loading: true})
    SostaOnlineApiService.fetchUserTypes().then((data) => {
      this.setState({userTypes: data.data, loading: false})
    })
  }

  fetchAreas () {
    SostaOnlineApiService.fetchAreas().then(data => {
      this.setState({areas: data.data})
    })
  }

  async fetchUserCategories () {
    this.setState({loading: true})
    return SostaOnlineApiService.fetchUserCategories().then((data) => {
      this.setState({categories: this.mapCategories(data.data), loading: false})
    })
  }

  onSubmit (data) {
    this.setState({loading: true, error: null, success: false})
    let isResident = data.userCategories.filter(item => item.value === 2).length > 0
    let isWorker = data.userCategories.filter(item => item.value === 3 || item.value === 4 || item.value === 5 || item.value === 6 || item.value === 7).length > 0
    let residenceCity = isResident ? 'Empoli' : null
    let workCity = isWorker ? 'Empoli' : null
    let obj = {
      id: this.state.userId,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
      fiscalCode: data.fiscalCode,

      residenceCity: residenceCity,
      residenceAddress: data.residenceAddress,
      residenceCivicNumber: data.residenceCivicNumber,
      residenceCap: data.residenceCap,
      sex: data.sex,
      birthDate: data.birthDate,
      birthPlace: data.birthPlace,

      secondaryResidenceCity: data.secondaryResidenceCity,
      secondaryResidenceAddress: data.secondaryResidenceAddress,
      secondaryResidenceCap: data.secondaryResidenceCap,

      workCity: workCity,
      workAddress: data.workAddress,
      workCivicNumber: data.workCivicNumber,
      workCap: data.workCap,
      companyName: data.companyName,
      companyLegalAddress: data.companyLegalAddress,
      vatNumber: data.vatNumber,
      userCategories: this.state.selectedCategories.map(item => item.value),
      workAreaId: data.workAreaId,
      residenceAreaId: data.residenceAreaId,
      parkSpaceAddressId: data.parkingSpaceAddress
    }

    SostaOnlineApiService.updateUser(obj).then(result => {
      this.setState({error: null, loading: false, success: true, userCreateResult: result})
    }).catch(err => {
      console.log(err)
      this.setState({error: 'Errore nella modifica utente', success: false, loading: false})
    })
  }

  onGenerateUserCredentials () {
    SostaOnlineApiService.generateUserCredentials(this.state.userId, randomPassword(8)).then(result => {
      this.setState({error: null, loading: false, success: true, userCreateResult: result})
    }).catch(err => {
      console.log(err)
      this.setState({error: 'Errore nella modifica utente', success: false, loading: false})
    })
  }

  onDeleteUser () {
    SostaOnlineApiService.deleteUser(this.state.userId).then(data => {
      this.props.history.push('/backoffice/users')
    }).catch(err => {
      console.log(err)
      this.setState({error: 'Errore nella modifica utente', success: false, loading: false})
    })
  }

  onCategoriesChange (selectedNodes) {
    this.setState({
      selectedCategories: selectedNodes.map(item => ({
        label: item.label,
        value: item.value,
        resident: item.resident,
        worker: item.worker,
        parkingInDifferentPlace: item.parkingInDifferentPlace
      }))
    })
  }

  onParkingSpaceAddressSelected (addressId) {
    if (!addressId) {
      this.setState({selectedParkingSpaceArea: null})
      return
    }

    let address = this.props.addresses.data.filter(item => {
      return item.id === addressId
    })
    this.setState({selectedParkingSpaceArea: address[0].Area})
  }

  render () {
    return (
      <BackOfficeUserEditScreen
        addresses={this.props.addresses}
        initialValues={this.state.values}
        categoryOptions={this.state.categories}
        user={this.state.user}
        loading={this.state.loading}
        error={this.state.error}
        success={this.state.success}
        result={this.state.result}
        comuni={ITALIA_COMUNI}
        comuniWithoutLodi={ITALIA_COMUNI_SENZA_LODI_E_ESTERO}
        areas={this.state.areas}
        onCategoriesChange={this.onCategoriesChange}
        selectedCategories={this.state.selectedCategories}
        onGenerateUserCredentials={this.onGenerateUserCredentials}
        onSubmit={this.onSubmit.bind(this)}
        selectedParkingSpaceArea={this.state.selectedParkingSpaceArea}
        onParkingSpaceAddressSelected={this.onParkingSpaceAddressSelected}
        onDeleteUser={this.onDeleteUser.bind(this)} />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserEditContainer)



// WEBPACK FOOTER //
// ./src/containers/BackOfficeUserEditContainer.js